@if (budgetQuery.selectLoading() | async) {
  <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
}

@if ((budgetQuery.selectLoading() | async) === false) {
  @if (showAnalyticsSection$ | async) {
    <div class="mt-8 grid grid-cols-3 gap-7.5">
      <div class="flex h-28 items-center justify-around rounded border border-aux-gray-dark py-3">
        <div class="flex flex-col justify-center rounded-l px-4 pr-1">
          <div class="font-bold text-aux-black">Actuals</div>
          <div class="flex items-center space-x-4">
            <div class="text-xs font-medium">
              % of Total
              <br />
              Current $
            </div>
          </div>
        </div>
        <div class="h-full bg-aux-gray-dark" style="width: 1px"></div>
        <div class="flex items-center justify-center space-x-2 rounded-r px-4 tabular-nums">
          @if ((wpLoading | async) === false) {
            @if (budgetQuery.select('work_performed') | async; as wp) {
              <div class="flex items-center justify-center space-x-2 rounded-r px-4">
                <div class="text-lg font-bold text-aux-gray-darkest">
                  {{
                    selectedVendor && selectedVendor.value
                      ? wp[selectedVendor.value]
                        ? wp[selectedVendor.value].wp_percentage
                        : zeroHyphen
                      : wp.ALL
                        ? wp.ALL.wp_percentage
                        : zeroHyphen
                  }}
                  <br />
                  {{
                    selectedVendor && selectedVendor.value
                      ? wp[selectedVendor.value]
                        ? wp[selectedVendor.value].wp_total
                        : zeroHyphen
                      : wp.ALL
                        ? wp.ALL.wp_total
                        : zeroHyphen
                  }}
                </div>
              </div>
            }
          }
        </div>
      </div>
      <div class="flex h-28 items-center justify-around rounded border border-aux-gray-dark py-3">
        <div class="flex flex-col justify-center rounded-l px-4 pr-14">
          <div class="font-bold text-aux-black">Invoiced</div>
          <div class="flex items-center space-x-4">
            <div class="text-xs font-medium">
              % of Total
              <br />
              Current $
            </div>
          </div>
        </div>
        <div class="h-full bg-aux-gray-dark" style="width: 1px"></div>
        <div class="flex items-center justify-center space-x-2 rounded-r px-4">
          @if ((invoicesTotalLoading | async) === false) {
            @if (budgetQuery.select('invoices') | async; as invoices) {
              <div class="flex items-center justify-center space-x-2 rounded-r px-4 tabular-nums">
                <div class="text-lg font-bold text-aux-gray-darkest">
                  {{
                    selectedVendor && selectedVendor.value
                      ? invoices[selectedVendor.value]
                        ? invoices[selectedVendor.value].invoice_percentage
                        : zeroHyphen
                      : invoices.ALL
                        ? invoices.ALL.invoice_percentage
                        : zeroHyphen
                  }}
                  <br />
                  {{
                    selectedVendor && selectedVendor.value
                      ? invoices[selectedVendor.value]
                        ? invoices[selectedVendor.value].invoice_total
                        : zeroHyphen
                      : invoices.ALL
                        ? invoices.ALL.invoice_total
                        : zeroHyphen
                  }}
                </div>
              </div>
            }
          }
        </div>
      </div>
      <div class="flex h-28 items-center justify-around rounded border border-aux-gray-dark py-3">
        <div class="flex flex-col justify-center rounded-l px-4 pr-1">
          <div class="font-bold text-aux-black">Pending Change</div>
          <div class="flex items-center space-x-4">
            <div class="text-xs font-medium">
              Change Log + Unsigned
              <br />
              Change Orders $
            </div>
          </div>
        </div>
        <div class="h-full bg-aux-gray-dark" style="width: 1px"></div>
        <div class="flex items-center justify-center space-x-2 rounded-r px-4">
          @if ((pendingChangesLoading | async) === false) {
            @if (budgetQuery.select('pendingChanges') | async; as pendingChanges) {
              <div class="flex items-center justify-center space-x-2 rounded-r px-4 tabular-nums">
                <div class="text-lg font-bold text-aux-gray-darkest">
                  {{
                    selectedVendor && selectedVendor.value
                      ? pendingChanges[selectedVendor.value]
                        ? pendingChanges[selectedVendor.value]
                        : zeroHyphen
                      : pendingChanges.ALL
                        ? pendingChanges.ALL
                        : zeroHyphen
                  }}
                </div>
              </div>
            }
          }
        </div>
      </div>
    </div>
  }

  <div #budgetFilters>
    <div class="flex items-start justify-between space-x-4">
      <div class="flex items-start justify-between space-x-4">
        <div class="flex flex-row items-center justify-between">
          <div class="mr-1 text-sm">Vendor Contract</div>
          <aux-vendor-dropdown
            [showAllOption]="true"
            [vendors]="vendors()"
            [formControl]="selectedVendor"
            (onChange)="onVendorSelected($event)"
          />
        </div>
        <div
          class="flex"
          [auxTooltip]="
            !isVendorCurrency
              ? 'Comparing to a snapshot is only supported in Vendor Contract Currency'
              : ''
          "
        >
          <aux-compare-dropdown
            class="mr-1.5"
            [initialValue]="compareToValue"
            [disabled]="!isVendorCurrency"
            [refreshTable]="refreshTable"
            (valueChange)="compareDropdownChange($event)"
          />
        </div>

        <div class="flex flex-row items-center justify-between">
          <div class="mr-1 text-sm">Period</div>
          <ng-select
            class="w-32"
            bindValue="value"
            [formControl]="selectedPeriodType"
            [clearable]="false"
            [multiple]="false"
            [searchable]="false"
            [items]="periodTypes"
          />
        </div>
      </div>
      <div class="flex items-start justify-between space-x-4">
        <div>
          <button
            type="button"
            class="btn-nr btn--white btn--secondary justify-end text-sm"
            (click)="onToggleBudgetGraph()"
          >
            @if (!showBudgetGraph) {
              <aux-icon name="ChartBar" />
            } @else {
              <aux-icon name="ChartBarOff" />
            }
            <span class="ml-2">{{ showBudgetGraph ? 'Hide' : 'Show' }} Graph</span>
          </button>
        </div>

        <div>
          <aux-menu
            #budget_menu
            [showMenuForExternal]="userHasUploadBudgetPermission"
            [disabled]="isChangeOrdersWorkflowLocked()"
            [disabledTooltip]="messagesConstants.LOCKED_FOR_PERIOD_CLOSE"
          >
            <button
              type="button"
              role="menuitem"
              class="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none"
              (click)="onBudgetUploadClick(); budget_menu.close()"
            >
              <aux-icon name="Upload" />
              <span class="ml-2">Upload Single Vendor Contract Budget</span>
            </button>

            @if (flags().multiVendorBudgetTemplate) {
              <button
                type="button"
                role="menuitem"
                class="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none"
                (click)="onMultipleVendorBudgetUploadClick(); budget_menu.close()"
              >
                <aux-icon name="Upload" />
                <span class="ml-2">Upload Multiple Vendor Contract Budgets</span>
              </button>
            }
          </aux-menu>
        </div>
      </div>
    </div>
  </div>

  <aux-progress-tracker
    [trackerId]="progressTrackerId()"
    (trackerIdChanged)="onTrackerIdChanged($event)"
    [validationInProgressCaption]="'Import Vendor Budget Template - Validation Progress'"
    [dataLoadInProgressCaption]="'Import Vendor Budget Template - Data Load Progress'"
    class="my-8 block"
  />

  <aux-progress-tracker
    [trackerId]="multiProgressTrackerId()"
    (trackerIdChanged)="onMultiTrackerIdChanged($event)"
    [validationInProgressCaption]="'Import Vendor Budget Template - Validation Progress'"
    [dataLoadInProgressCaption]="'Import Vendor Budget Template - Data Load Progress'"
    class="my-8 block"
  />

  @if (budgetCanvas$ | async; as budgetCanvas) {
    @if (showBudgetGraph) {
      <div class="my-8 grid" style="height: 250px">
        <canvas
          baseChart
          [labels]="budgetCanvas.data.labels"
          [datasets]="(canvasDatasets$ | async)!"
          [options]="budgetCanvas.options"
          [type]="budgetCanvas.type"
        ></canvas>
        @if (isSnapShotSelected$.getValue().selected) {
          <div class="flex justify-center">
            <div class="mr-4 flex items-center" (click)="chartLegendClick(true)">
              <div
                class="mr-1 h-3 w-3 rounded-full bg-aux-blue-dark"
                [ngClass]="{
                  'opacity-50': !this.isSnapShotSelected$.getValue().currentLegend,
                  'opacity-100': this.isSnapShotSelected$.getValue().currentLegend,
                }"
              ></div>
              <span
                [ngClass]="{
                  'line-through': !this.isSnapShotSelected$.getValue().currentLegend,
                  'no-underline': this.isSnapShotSelected$.getValue().currentLegend,
                }"
              >
                Current (LRE) Budget
              </span>
            </div>
            <div class="flex items-center" (click)="chartLegendClick()">
              <div
                class="mr-1 h-3 w-3 rounded-full bg-aux-green-dark"
                [ngClass]="{
                  'opacity-50': !this.isSnapShotSelected$.getValue().snapShotLegend,
                  'opacity-100': this.isSnapShotSelected$.getValue().snapShotLegend,
                }"
              ></div>
              <span
                [ngClass]="{
                  'line-through': !this.isSnapShotSelected$.getValue().snapShotLegend,
                  'no-underline': this.isSnapShotSelected$.getValue().snapShotLegend,
                }"
              >
                {{ this.compareToValue }}
              </span>
            </div>
          </div>
        }
      </div>

      <hr class="mb-8" />
    }
  }

  <div style="width: 100%; overflow: auto">
    <div class="mb-8 flex items-center justify-between" style="margin-top: 1px">
      <div class="flex">
        <div
          class="flex w-60 items-center justify-between rounded-md border border-aux-gray-dark px-3 text-sm font-medium shadow-sm"
          (click)="openCustomList()"
        >
          @if (selectedCustom$ | async; as selectedCustom) {
            <span class="text-sm">{{ selectedCustom }}</span>
          } @else {
            <ng-template #placeholderTemplate1>
              <span class="text-gray-500"></span>
            </ng-template>
          }

          <aux-icon name="ChevronDown" class="text-aux-gray-darkest" />
        </div>
        <div>
          <div #customTrigger="cdkOverlayOrigin" class="mt-11" cdkOverlayOrigin></div>
        </div>

        <ng-template
          cdkConnectedOverlay
          class="border-solid border-aux-gray-dark-100"
          [cdkConnectedOverlayOrigin]="customTrigger"
          [cdkConnectedOverlayOpen]="isCustomOpen"
          [cdkConnectedOverlayHasBackdrop]="true"
          [cdkConnectedOverlayBackdropClass]="'ttt'"
          [cdkConnectedOverlayPositions]="positions"
          (backdropClick)="closeCustomList()"
          (detach)="closeCustomList()"
        >
          <ul
            tabindex="-1"
            class="mt-1 max-h-100 w-60 overflow-auto rounded-md border-solid border-aux-gray-light bg-white py-1 text-base ring-1 focus:outline-none sm:text-sm"
          >
            @for (
              item of customValues$ | async;
              track item;
              let index = $index;
              let first = $first
            ) {
              <li
                class="relative flex cursor-default select-none flex-col text-gray-900"
                (click)="customChanges(item)"
              >
                @if (item.showLine && !first) {
                  <div class="mb-2 ml-2 mr-2 mt-1 h-1 border-b border-aux-gray-lightest"></div>
                }

                <div
                  class="relative flex cursor-default select-none justify-between py-2 pl-2 text-gray-900"
                  [ngClass]="{
                    'bg-aux-gray-light': index === (highlightedCustom | async),
                  }"
                  (mouseenter)="highlightCustom(index)"
                  (mouseleave)="highlightedCustom.next(null)"
                >
                  {{ item.name }}
                  <div class="mr-2 flex">
                    @if (item.is_custom) {
                      <aux-icon
                        name="Pencil"
                        class="mr-1 w-3 text-aux-blue-dark"
                        (click)="editCustom(item)"
                      />
                      <aux-icon
                        name="Trash"
                        (click)="removeCustom(item)"
                        class="w-3 text-aux-red-hover"
                      />
                    }
                  </div>
                </div>
              </li>
            }
          </ul>
        </ng-template>
        <aux-button
          classList="ml-2 mr-2"
          variant="secondary"
          label="Columns"
          icon="Eye"
          [onClick]="onColumnChooser.bind(this)"
        />
        <aux-button
          classList="whitespace-nowrap"
          variant="secondary"
          [disabled]="!areUnsavedChanges"
          label="Save View"
          icon="DeviceFloppy"
          [onClick]="saveCustomUserView.bind(this)"
        />
        <div class="ml-4 flex items-center">
          <div class="text-sm">
            <span>Years</span>
          </div>
          <div
            class="ml-1 flex h-10 w-[120px] items-center justify-between rounded-md border border-aux-gray-dark px-3 text-sm font-medium shadow-sm"
            (click)="openList()"
          >
            @if (selectedYear) {
              <span class="text-sm">{{ selectedYear }}</span>
            } @else {
              <ng-template #placeholderTemplate2>
                <span class="text-gray-500"></span>
              </ng-template>
            }

            <aux-icon name="ChevronDown" class="text-aux-gray-darkest" />
          </div>

          <div>
            <div #trigger="cdkOverlayOrigin" class="mt-11" cdkOverlayOrigin></div>
          </div>
          <ng-template
            cdkConnectedOverlay
            class="border-solid border-aux-gray-dark-100"
            [cdkConnectedOverlayOrigin]="trigger"
            [cdkConnectedOverlayOpen]="isYearsOpen"
            [cdkConnectedOverlayHasBackdrop]="true"
            [cdkConnectedOverlayBackdropClass]="'ttt'"
            [cdkConnectedOverlayPositions]="positions"
            (backdropClick)="closeList()"
            (detach)="closeList()"
          >
            <ul
              tabindex="-1"
              class="w-28 overflow-auto rounded-md border-solid border-aux-gray-light bg-white py-1 text-base text-gray-900 ring-1 focus:outline-none sm:text-sm"
            >
              @for (item of years; track item; let index = $index) {
                <li class="relative flex cursor-default select-none py-2 pl-2">
                  <aux-checkbox
                    [checked]="item.enabled"
                    (customChange)="yearChanged($event, item.label)"
                  />
                  {{ item.label }}
                </li>
              }
            </ul>
          </ng-template>
          @if (
            (numberOfVendorCurrencies > 1 || !isVendorCurrenciesUSD) &&
            (vendorCurrencyEnabled$ | async)
          ) {
            <div
              class="flex items-center justify-between"
              [auxTooltip]="
                isSnapShotSelected$.getValue().selected
                  ? 'Comparing to a snapshot is only supported in Vendor Contract Currency'
                  : ''
              "
            >
              <aux-toggle-budget-currency
                class="ml-4"
                [value]="isVendorCurrency"
                [disabled]="isSnapShotSelected$.getValue().selected"
                (nameSelectedCurrency)="selectedBudgetCurrencyType$.next($event)"
              />
            </div>
          }
        </div>
      </div>
      <div class="flex">
        @if (flags().showEditButton) {
          <aux-button-group
            iconName="Pencil"
            label="Edit"
            [options]="editOptions()"
            class="mr-2"
            [disabled]="editButtonGroupDisabled()"
            [loading]="activitiesModal.categoriesLoading()"
            [disabledMultiTooltip]="editButtonGroupDisabledReasons()"
          />
        }
        @if (showSnapshotSection$ | async) {
          <div
            [auxTooltip]="
              !isVendorCurrency ? 'Snapshot can only be taken in Vendor Contract Currencies' : ''
            "
          >
            <aux-button
              [label]="'Snap'"
              icon="CameraPlus"
              [variant]="'secondary'"
              [onClick]="openSnapshotModal.bind(this)"
              [disabled]="
                vendors().length === 1
                  ? !isVendorCurrency
                  : !!selectedVendor.value || !isVendorCurrency || !vendors().length
              "
            />
          </div>
          <div class="mx-2.5 border-l border-solid border-l-aux-gray-dark"></div>
          <aux-export-excel-button
            [clickFN]="onBudgetExportClick.bind(this)"
            pendoTag="budget-enhanced-excel-export-button"
          />
        }
      </div>
    </div>
    @if (showGrid$ | async) {
      <ag-grid-angular
        domLayout="autoHeight"
        class="ag-theme-aux budget-enhanced-table tabular-nums"
        [gridOptions]="(gridOptions$ | async)!"
        [rowData]="gridData$ | async"
        [postProcessPopup]="postProcessPopup"
        [groupAllowUnbalanced]="true"
        (firstDataRendered)="onDataRendered($event); scrollToColumnByRouteParams()"
        (modelUpdated)="modelUpdated()"
        (filterChanged)="onFilterChanged($event)"
        (gridReady)="onGridReady($event)"
        (selectionChanged)="onSelect()"
        auxStickyGrid
      />
    }
  </div>
}
